
import HomePage from "./list/HomePage.vue";
import PronosticsPage from "./list/PronosticsPage.vue";

const routes = [
  {
    path: '/',
    redirect: 'home'
  },
  {
    path: '/pronostics',
    name: 'pronostics',
    component: PronosticsPage,
    meta: {
      title: 'Pronostics',
      requiresAuth: true,
    }
  },
  {
    path: '/home',
    name: 'home',
    component: HomePage,
    meta: {
      title: 'Accueil',
      requiresAuth: true,
    }
  }
];

export default routes;
